<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jRPZMD/images/cover.jpg?1685327317421" alt="This image is the cover for the book Monkey Wrench, Were Menagerie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monkey Wrench, Were Menagerie
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Were Menagerie Story</i></b></p><p>Twenty-year-old virgin Aaron Thorne has a lot of irons in the fire. He’s on a career-making case investigating a new party drug that induces shifts in werecreatures, and his friend is the prime suspect. Outside of work, a literal silver fox has captured his attention. And just when life start going smoothly for Aaron, a tall, dark, scowly bobcat shifter named Iggy appears and sweeps him off his feet.</p> <p>After being attacked in the course of his investigation, Aaron starts to feel like he has something to prove. It’s a good thing he’s got all the energy of his shifter animal, the spider monkey. He’s going to need it to solve the case, sort out his love life, and decide what kind of man he wants to be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Xara X. Xanakas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a47691a